/**
 * Custom hook for manual DataDog RUM view tracking
 * Tracks route changes and sends view data to DataDog
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { startDataDogView } from 'Core/datadog';

/**
 * Hook to track page views in DataDog RUM
 * Should be used in a component that wraps all routes
 *
 * @example
 * function App() {
 *   useDataDogViewTracking();
 *   return <Routes>...</Routes>;
 * }
 */
export const useDataDogViewTracking = () => {
    const location = useLocation();

    useEffect(() => {
        // Create a readable view name from the pathname
        const pathparts = location.pathname.split('/').filter(Boolean);
        const viewName = pathparts.length > 0
            ? pathparts.join(' > ')
            : 'home';

        // Track the view in DataDog
        startDataDogView(viewName, {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        });

        console.log(`[DataDog] View tracked: ${viewName} (${location.pathname})`);
    }, [location.pathname, location.search]);
};

export default useDataDogViewTracking;

